import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {BandFileInfo} from "src/models/BandFileInfo";
import {RenderRequestModel} from "src/models/RenderRequestModel";
import {SettingsModel} from "src/models/SettingsModel";

const emptyRenderRequest: RenderRequestModel = {
  abnormalColorOverrides: [],
  stainColorOverrides: [],
  bandFile: "400 Band",
  fileFormat: "Png",
  excludedChromosomes: [],
  excludedAbnormalityTypes: [],
  cytoBandFile: undefined,
  sampleFile: undefined,
  genesFile: undefined,
  hideUnusedAbnormalityTypes: false,
  renderLayout: 'Linear',
  translocationFile: undefined,
};
const BuildRenderRequestSlice = createSlice({
  initialState: emptyRenderRequest,
  name: "buildRenderRequest",
  reducers: {
    setExcludedChromosomes: (draft, action: PayloadAction<Array<string>>) => {
      draft.excludedChromosomes = action.payload;
    },
    setExcludedAbnormalityTypes: (draft, action: PayloadAction<Array<string>>) => {
      draft.excludedAbnormalityTypes = action.payload;
    },
    setAbnormalColorOverrides: (
      draft,
      action: PayloadAction<Array<SettingsModel>>,
    ) => {
      draft.abnormalColorOverrides = action.payload;
    },
    setStainColorOverrides: (
      draft,
      action: PayloadAction<Array<SettingsModel>>,
    ) => {
      draft.stainColorOverrides = action.payload;
    },


    setCytoBandFile: (draft, action: PayloadAction<File | undefined>) => {
      draft.cytoBandFile = action.payload;
    },
    setSampleFile: (draft, action: PayloadAction<File | undefined>) => {
      draft.sampleFile = action.payload;
    },
    setGenesFile: (draft, action: PayloadAction<File | undefined>) => {
      draft.genesFile = action.payload;
    },
    setFileFormat: (draft, action: PayloadAction<string>) => {
      draft.fileFormat = action.payload;
    },
    setHideUnusedAbnormalityTypes: (draft, action: PayloadAction<boolean>) => {
      draft.hideUnusedAbnormalityTypes = action.payload;
    },
    setBandFile: (draft, action: PayloadAction<string>) => {
      console.log("setBandFile reducer called with:", action.payload);
      draft.bandFile = action.payload;
    },
    setRenderLayout: (draft, action: PayloadAction<'Linear' | 'Circular'>) => {
      draft.renderLayout = action.payload;
    },
    setTranslocationFile: (draft, action: PayloadAction<File | undefined>) => {
      draft.translocationFile = action.payload;
    },
  },
});

export const {
  setAbnormalColorOverrides,
  setCytoBandFile,
  setExcludedChromosomes,
  setFileFormat,
  setSampleFile,
  setStainColorOverrides,
  setHideUnusedAbnormalityTypes,
  setExcludedAbnormalityTypes,
  setGenesFile,
  setBandFile,
  setRenderLayout,
  setTranslocationFile,
} = BuildRenderRequestSlice.actions;
export default BuildRenderRequestSlice;
